import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared";
import { UploaderComponent } from "./uploader.component";

/**
 * Expose UploaderComponent en tant que composant réutilisable (page d'import dédiée
 * ET pop-up d'import ouverte depuis la liste DAM). Importé par UploadModule (route)
 * et ThumbsnailContainerModule (pop-up).
 */
@NgModule({
    imports: [SharedModule],
    declarations: [UploaderComponent],
    exports: [UploaderComponent],
})
export class UploaderModule {}
